import { Box, FormControlLabel, Grid, Radio, Typography, useTheme } from "@mui/material"
import React from "react"
import { useTranslation } from "react-i18next"
import { IOptionProps } from "components/Form/FormOption/formoption.interface"
import { styled } from "@mui/material/styles";
import { RadioProps } from "components/Form/FormComponents/FormRadioButtons/FormRadioButtons.interfaces";

export interface IFormRadioButtons {
  id: number | string
  value: any
  options?: IOptionProps[]
  handleClick?: (value: any) => void
  labelKey?: string
  labelDefault?: string
  helperText?: React.ReactNode
  error?: boolean
}

export const StyledSmallRadioBox = styled(Box)<RadioProps>(({ theme, isSelected }) => ({
  display: "flex",
  alignItems: "start",
  border: isSelected ? `2px solid ${theme.palette.primary["main"]}` : "2px solid transparent",
  boxShadow: "1px 3px 3px 0px rgba(0, 0, 0, 0.10)",
  borderRadius: "5px",
  cursor: "pointer",
  backgroundColor: theme.palette.background.paper,
}))

const FormRadioButtons: React.FC<IFormRadioButtons> = (props) => {
  const { options, value, handleClick, labelKey, labelDefault, error, helperText } = props
  const { t } = useTranslation()
  const theme = useTheme()

  return (
    <Grid
      container
      gap="3px"
      mb={2}
      sx={{
        border: error && helperText ? `1px solid ${theme.palette.error.main}` : "none",
        borderRadius: error && helperText ? "5px" : "none",
        padding: error && helperText ? "8px" : "0",
      }}
    >
      <Typography variant="h5" mb={1}>{t(labelKey || "", labelDefault || "")}</Typography>
      {options?.map((option, index) => {
        return (
          <Grid md={12} xs={12} key={index}>
            <StyledSmallRadioBox
              px={1}
              py={1}
              my={0.5}
              onClick={() => handleClick && handleClick(option.value)}
              isSelected={value === option.value}>
              <FormControlLabel
                sx={{ margin: 0, display: "flex", alignItems: "start" }}
                value={option.value}
                control={<Radio sx={{ padding: 0 }} checked={value === option.value} />}
                label={
                  <Box ml={2}>
                    <Typography variant="labelMedium">{t(option.labelKey || "", { defaultValue: option.labelDefault })}</Typography>
                    {option?.descriptionDefault && (
                      <Typography variant="bodySmall" color="textSecondary">
                        {t(option.descriptionKey || "", { defaultValue: option.labelDefault })}
                      </Typography>
                    )}
                  </Box>
                }
              />
            </StyledSmallRadioBox>
          </Grid>
        )
      })}
      {error && helperText && (
        <Typography color="error" mb={1} variant="helptext">
          {helperText}
        </Typography>
      )}
    </Grid>
  )
}

export default FormRadioButtons
